export default __webpack_public_path__ + "static/media/radial_1.b366e706.png";